const floatingButtonText = document.createElement('span');
const floatingButtonInner = document.createElement('span');
const floatingButton = document.createElement('a');

/**
 * Set floating button placement based on sticky ad.
 */
const setFloatingButtonPlacement = () => {
  const stickyAd = document.getElementById('dfp-mobile-footer');

  const scrollToTopBottomDistance = (stickyAd && stickyAd.offsetHeight) ? stickyAd.offsetHeight : 8;

  floatingButton.style.bottom = `${scrollToTopBottomDistance}px`;
};

/**
 * Show floating button if content section is in view.
 */
const contentSectionShowButton = () => {
  const contentSection = document.querySelector('.content-section[style*="display: block"]');
  const contentSectionObserver = new window.IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      floatingButton.style.display = 'flex';
    }
  }, {
    root: null,
    threshold: 0,
  });

  contentSectionObserver.observe(contentSection);
};

// add floating button in DOM
window.addEventListener('DOMContentLoaded', () => {
  const paginationNav = document.querySelector('.pagination');
  floatingButtonInner.classList.add('button--pagination-next-page');
  floatingButtonInner.classList.add('floating-button-inner');
  floatingButtonText.classList.add('floating-button-text');
  floatingButtonText.innerHTML = 'Next Page';

  floatingButton.classList.add('floating-button');

  floatingButtonInner.appendChild(floatingButtonText);
  floatingButton.appendChild(floatingButtonInner);

  // add floating button in pagination nav
  paginationNav.appendChild(floatingButton);
});

// Get next page button properties and apply to floating button
window.addEventListener('load', () => {
  const nextPageLink = document.getElementById('next-page-link');

  floatingButton.href = nextPageLink.href;

  setFloatingButtonPlacement();

  contentSectionShowButton();
});

// Handle floating text expanding/shrinking on scroll
let timer = null;
window.addEventListener('scroll', () => {
  // sticky ad may resize in lifecycle so adjust the button placement while scrolling
  setFloatingButtonPlacement();

  // shrink text while scrolling
  setTimeout(() => {
    floatingButtonText.classList.remove('floating-button-text--expand');
  }, 500);

  if (timer !== null) {
    clearTimeout(timer);
  }
  // when scrolling is stopped, expand the text in the button
  timer = setTimeout(() => {
    floatingButtonText.classList.add('floating-button-text--expand');
  }, 2000);
}, false);

// toggle button scale animation on click
floatingButton.addEventListener('click', (event) => {
  event.preventDefault();

  floatingButton.classList.remove('floating-button--animation');

  setTimeout(() => {
    floatingButton.classList.add('floating-button--animation');
  }, 0);
});
